
    import React, { Fragment } from 'react';
    
    
    const Markdown = () => (<Fragment><h1 id="2363">2.36.3</h1>
<p><em><strong>Released</strong>: March 9, 2026</em></p>
<h2 id="updates">Updates</h2>
<ul>
<li>Added internal check for daily vendor updates</li>
<li>Updated vendor packages to their latest versions</li>
</ul>
<hr/>
<h1 id="2362">2.36.2</h1>
<p><em><strong>Released</strong>: August 25, 2025</em></p>
<h2 id="bug-fix">Bug Fix</h2>
<ul>
<li>Fixed an issue where video thumbnails in the &quot;Thumbnail Selector&quot; would cause performance issues.</li>
</ul>
<hr/>
<h1 id="2361">2.36.1</h1>
<p><em><strong>Released</strong>: July 11, 2025</em></p>
<ul>
<li>Removed a duplicative analytics report</li>
</ul>
<hr/>
<h1 id="2360">2.36.0</h1>
<p><em><strong>Released</strong>: June 6, 2025</em></p>
<h2 id="feature">Feature</h2>
<ul>
<li>Added a new &quot;Thumbnail Selector&quot; utility to the Event&#39;s functionality within the Assets tab<ul>
<li>Documentation can be found here: <a href="https://invintus-support.freshdesk.com/support/solutions/articles/48001272377-event-thumbnails">https://invintus-support.freshdesk.com/support/solutions/articles/48001272377-event-thumbnails</a></li>
</ul>
</li>
</ul>
<hr/>
<h1 id="23539">2.35.39</h1>
<p><em><strong>Released</strong>: May 16th, 2025</em></p>
<h2 id="bug-fix-1">Bug Fix</h2>
<ul>
<li>Fixed an issue where the Events Listing views would crash</li>
</ul>
<hr/>
<h1 id="23538">2.35.38</h1>
<p><em><strong>Released</strong>: March 14th, 2025</em></p>
<h2 id="bug-fix-2">Bug Fix</h2>
<ul>
<li>Fixed an issue where Published Media download URLs would generate an invalid path</li>
</ul>
<hr/>
<h1 id="23537">2.35.37</h1>
<p><em><strong>Released</strong>: February 28th, 2025</em></p>
<h2 id="bug-fix-3">Bug Fix</h2>
<ul>
<li>Fixes an issue introduced in v2.35.30 which would cause the Events Listing views to crash</li>
</ul>
<hr/>
<h1 id="23536">2.35.36</h1>
<p><em><strong>Released</strong>: February 18th, 2025</em></p>
<h2 id="hotfix">Hotfix</h2>
<h3 id="agenda-logger">Agenda Logger</h3>
<ul>
<li>Fixes an issue introduced in v2.35.35 causing staged Attendee Log Items to render incorrectly.</li>
</ul>
<hr/>
<h1 id="23535">2.35.35</h1>
<p><em><strong>Released</strong>: February 14th, 2025</em></p>
<h2 id="agenda-logger-1">Agenda Logger</h2>
<ul>
<li>Fixed an issue where certain characters weren&#39;t rendering correctly.<ul>
<li>Predominantly these were URI encoded characters such as: &quot;&amp;&quot;, &quot;&lt;&quot;, and &quot;&gt;&quot;</li>
</ul>
</li>
<li>Fixed an issue where users without sufficient permissions were able to Start/Stop/Pause Events from within the Agenda Logger</li>
</ul>
<hr/>
<h1 id="23534">2.35.34</h1>
<p><em><strong>Released</strong>: February 8th, 2025</em></p>
<h2 id="feature-1">Feature</h2>
<ul>
<li>Added New Preference for Embedded Media Players:<ul>
<li>&quot;List Audio Files in Documents Tab&quot;</li>
<li>This allows you to show any and all MP3 files in your Documents list in the Player</li>
<li>Toggled Off by default for all existing Player preferences.</li>
</ul>
</li>
</ul>
<hr/>
<h1 id="23533">2.35.33</h1>
<p><em><strong>Released</strong>: January 22nd, 2025</em></p>
<h2 id="hotfix-1">Hotfix</h2>
<ul>
<li>Fixed an issue where users could assign a different Encoder to an Event while the Event was in a Stopping state</li>
</ul>
<hr/>
<h1 id="23532">2.35.32</h1>
<p><em><strong>Released</strong>: January 21st, 2025</em></p>
<h2 id="hotfix-2">Hotfix</h2>
<ul>
<li>Fixed an issue where users could not select Slates for their Player Preferences.</li>
</ul>
<h2 id="agenda-logger-2">Agenda Logger</h2>
<h3 id="hotfix-3">Hotfix</h3>
<ul>
<li>Fixed an issue where active log would disappear when Event Statuses changed.</li>
</ul>
<hr/>
<h1 id="23531">2.35.31</h1>
<p><em><strong>Released</strong>: January 16th, 2025</em></p>
<h2 id="agenda-logger-3">Agenda Logger</h2>
<h3 id="hotfix-4">Hotfix</h3>
<ul>
<li>Fixed an issue with exporting Agendas to their associated Event as PDFs.</li>
</ul>
<hr/>
<h1 id="23530">2.35.30</h1>
<p><em><strong>Released</strong>: January 14th, 2025</em></p>
<h2 id="agenda-logger-4">Agenda Logger</h2>
<h3 id="bug-fixes">Bug Fixes</h3>
<ul>
<li>Massively improved application performance and responsiveness!!!</li>
<li>Addressed conditions where certain screen resolutions would result in the controls of the Agenda Logger&#39;s media player to be cut off by the browser viewport</li>
</ul>
<hr/>
<h1 id="v23529">v2.35.29</h1>
<p><em><strong>Released</strong>: January 10th, 2025</em></p>
<h3 id="updates-1">Updates</h3>
<ul>
<li>Prep for staging release; added Agenda Logger known issues to internal documentation.</li>
</ul>
<hr/>
<h1 id="v23528">v2.35.28</h1>
<p><em><strong>Released</strong>: December 10th, 2024</em></p>
<h3 id="hotfix-5">Hotfix</h3>
<ul>
<li>Fixed a critical configuration issue.</li>
</ul>
<hr/>
<h1 id="v23527">v2.35.27</h1>
<p><em><strong>Released</strong>: December 6th, 2024</em></p>
<h3 id="bug-fixes-1">Bug Fixes</h3>
<ul>
<li>Fixed an issue with the Encoder Select dropdown on the Events page where listing too many Encoders would not allow the user to scroll to the bottom of the list.</li>
</ul>
<hr/>
<h1 id="v23526">v2.35.26</h1>
<p><em><strong>Released</strong>: November 15th, 2024</em></p>
<h3 id="bug-fixes-2">Bug Fixes</h3>
<ul>
<li>In the Event&#39;s Asset Tab, fixed an issue where Publishing Assets wouldn&#39;t show the Progress bar or correct status of the Asset.</li>
<li>Patched an issue that would allow for deletion of Events while in a Starting or Stopping state.</li>
</ul>
<hr/>
<h1 id="v23525">v2.35.25</h1>
<p><em><strong>Released</strong>: June 10th, 2024</em></p>
<h3 id="feature-2">Feature</h3>
<ul>
<li>Added new preference: Pagination positioning.<ul>
<li>You can now select to show the Pagination on Top/Above of the listing, Below it, or both.</li>
</ul>
</li>
</ul>
<hr/>
<h1 id="v23524">v2.35.24</h1>
<p><em><strong>Released</strong>: June 7th, 2024</em></p>
<h3 id="bug-fixes-3">Bug Fixes</h3>
<ul>
<li>Fixed an issue with the Year dropdown in the Ad Campaign Analytics view.</li>
</ul>
<hr/>
<h1 id="v23523">v2.35.23</h1>
<p><em><strong>Released</strong>: May 15th, 2024</em></p>
<h3 id="bug-fixes-4">Bug Fixes</h3>
<ul>
<li>Updating a vendor resource to the latest version</li>
</ul>
<hr/>
<h1 id="v23522">v2.35.22</h1>
<p><em><strong>Released</strong>: April 12th, 2024</em></p>
<h3 id="bug-fixes-5">Bug Fixes</h3>
<ul>
<li>Addressed two issues concerning Media Playback and Downloads within the Events View and the Agenda Logger</li>
</ul>
<hr/>
<h1 id="v23521">v2.35.21</h1>
<p><em><strong>Released</strong>: March 4th, 2024</em></p>
<h3 id="hotfix-6">Hotfix</h3>
<ul>
<li>Applied performance improvements to the Events Listing when viewing large amounts of Events at once.</li>
<li>Fixed an issue with the Agenda Logger&#39;s default Search queries</li>
</ul>
<hr/>
<h1 id="v23520">v2.35.20</h1>
<p><em><strong>Released</strong>: February 23rd, 2024</em></p>
<ul>
<li>Updated the Agenda Logger to fix two issues:<ul>
<li>Overlapping Log Item in the PDF Rendering process</li>
<li>Fixed an issue that wouldn&#39;t allow updates to the Attendees</li>
</ul>
</li>
</ul>
<hr/>
<h1 id="v23517">v2.35.17</h1>
<p><em><strong>Released</strong>: December 12th, 2023</em></p>
<ul>
<li>Fixed an issue regarding bold fonts not showing working within the Agenda Logger.</li>
</ul>
<hr/>
<h1 id="v23519">v2.35.19</h1>
<p><em><strong>Released</strong>: December 22nd, 2023</em></p>
<ul>
<li>Fixed an issue with listing Twitter as a valid Social Streaming destination.</li>
</ul>
<hr/>
<h1 id="v23517-1">v2.35.17</h1>
<p><em><strong>Released</strong>: December 13th, 2023</em></p>
<ul>
<li>Fixed an issue regarding bold fonts not showing working within the Agenda Logger.</li>
</ul>
<hr/>
<h1 id="v23518">v2.35.18</h1>
<p><em><strong>Released</strong>: December 22nd, 2023</em></p>
<h3 id="hotfix-7">Hotfix</h3>
<ul>
<li>Re-included Twitter/Periscope as a valid Social Streaming destination after it was inadvertently removed.</li>
</ul>
<hr/>
<h1 id="v23516">v2.35.16</h1>
<p><em><strong>Released</strong>: September 29th, 2023</em></p>
<h3 id="patch">Patch</h3>
<ul>
<li>Updated Facebook Live Streaming instructions has that process has been updated by Facebook/Meta.</li>
</ul>
<hr/>
<h1 id="v23515">v2.35.15</h1>
<p><em><strong>Released</strong>: September 8th, 2023</em></p>
<ul>
<li>Updated the Event Analytics view to include Video and Audio Download reports</li>
</ul>
<hr/>
<h1 id="v23514">v2.35.14</h1>
<p><em><strong>Released</strong>: June 26th, 2023</em></p>
<h3 id="hotfix-8">Hotfix</h3>
<ul>
<li>Resolved error in calculating current month overage, present since v2.35.13</li>
</ul>
<hr/>
<h1 id="v23513">v2.35.13</h1>
<p><em><strong>Released</strong>: June 16th, 2023</em></p>
<ul>
<li>The account page has been updated to provide more accurate usage information</li>
</ul>
<hr/>
<h1 id="v23512">v2.35.12</h1>
<p><em><strong>Released</strong>: June 5th, 2023</em></p>
<ul>
<li>Hotfix to replace the icons within the Video Editor</li>
</ul>
<hr/>
<h1 id="v23511">v2.35.11</h1>
<p><em><strong>Released</strong>: June 1st, 2023</em></p>
<ul>
<li>Hide &quot;Viewers Watching&quot; while Event is not in a Live State.<ul>
<li>Our Analytics provider was sending cached/stale responses for &quot;Viewers Watching&quot; long after Events had ended. This change does not affect the viewership metrics.</li>
</ul>
</li>
<li>Migrated all UI Icons to cloud provider to help serve them more consistently.</li>
</ul>
<hr/>
<h1 id="v23510">v2.35.10</h1>
<p><em><strong>Released</strong>: May 19th, 2023</em></p>
<ul>
<li>Merged in patches to the integrated Agenda Logger &#40;<code>v1.5.130</code>&#41;<ul>
<li>Addresses an issue which caused Header and Footer misalignments in the Agenda PDF Exporter.</li>
<li>Changed the default Excused member formatting, accepts &quot;Display Text&quot; as drop-in replacement.</li>
<li>Fixed an issue in the Global Index manager causing certain Security Groups to not be able to save changes.</li>
<li>Updates to help prevent a &quot;subType&quot; error from being raised when trying to edit Log Items.</li>
</ul>
</li>
</ul>
<hr/>
<h1 id="v2359">v2.35.9</h1>
<p><em><strong>Released</strong>: May 2nd, 2023</em></p>
<ul>
<li>Release notes for Media Player hotfix; please refer to notes for Hosted Player <code>v2.7.5</code></li>
</ul>
<hr/>
<h1 id="v2358">v2.35.8</h1>
<p><em><strong>Released</strong>: April 19th, 2023</em></p>
<h3 id="updates-2">Updates</h3>
<ul>
<li>Updated dependencies</li>
</ul>
<hr/>
<h1 id="v2357">v2.35.7</h1>
<p><em><strong>Released</strong>: March 21st, 2023</em></p>
<h3 id="hotfix-9">Hotfix</h3>
<p><strong>Agenda Logger:</strong></p>
<ul>
<li>Patch released to address an issue where duplicate file uploads were being created by the Agenda Logger&#39;s Agenda/Minutes export tool.</li>
</ul>
<hr/>
<h1 id="v2356">v2.35.6</h1>
<p><em><strong>Released</strong>: March 17th, 2023</em></p>
<h3 id="bug-fixes-6">Bug Fixes</h3>
<p><strong>Agenda Logger:</strong></p>
<ul>
<li>Addressed an issue which was preventing certain Templates to load within the Agenda PDF Exporter</li>
</ul>
<hr/>
<h1 id="v2355">v2.35.5</h1>
<p><em><strong>Released</strong>: March 3rd, 2023</em></p>
<h3 id="bug-fixes-7">Bug Fixes</h3>
<p><strong>Agenda Logger:</strong></p>
<ul>
<li>Addressed an issue in the Agenda Logger search page where real-time updates would populate the List of Events incorrectly if category or date filters were applied.</li>
</ul>
<hr/>
<h1 id="v2354">v2.35.4</h1>
<p><em><strong>Released</strong>: February 24th, 2023</em></p>
<h3 id="bug-fixes-8">Bug Fixes</h3>
<p><strong>Batch Event Importer:</strong></p>
<ul>
<li>Fixed a bug where Encoders were not being assigned to Events correctly after being successfully imported</li>
</ul>
<hr/>
<h1 id="v2353">v2.35.3</h1>
<p><em><strong>Released</strong>: February 2nd, 2023</em></p>
<h3 id="bug-fixes-9">Bug Fixes</h3>
<p><strong>Events:</strong></p>
<ul>
<li>Problem with event descriptions appearing as &quot;null&quot; has been fixed.</li>
<li>Clearing the event description field and updating an event now displays &quot;No Description Set&quot; instead of an empty space.</li>
</ul>
<hr/>
<h1 id="v2352">v2.35.2</h1>
<p><em><strong>Released</strong>: January 26th, 2023</em></p>
<h3 id="bug-fixes-10">Bug Fixes</h3>
<p><strong>Agenda Logger:</strong></p>
<ul>
<li>Fixes a bug where event action buttons &#40;&quot;Start&quot;, &quot;Stop&quot;, &quot;Pause&quot;&#41; wouldn&#39;t correspondingly enable or disable with regard to the Event&#39;s status.</li>
</ul>
<h3 id="features">Features</h3>
<p><strong>Events:</strong></p>
<ul>
<li>Events View &quot;Live Events Only&quot; Filter:<ul>
<li>When enabled, this filter will show events that are currently live, now including events that are in the &quot;on break&quot; state.</li>
</ul>
</li>
</ul>
<hr/>
<h1 id="v2351">v2.35.1</h1>
<p><em><strong>Released</strong>: December 16th, 2022</em></p>
<h3 id="bug-fixes-11">Bug Fixes</h3>
<p><strong>Video Editor:</strong></p>
<ul>
<li>Fixes a bug where playback control would become locked up while clipping an asset during media playback.</li>
</ul>
<hr/>
<h1 id="v2350">v2.35.0</h1>
<p><em><strong>Released</strong>: November 18th, 2022</em></p>
<h3 id="features-1">Features</h3>
<p><strong>Events:</strong></p>
<ul>
<li><a href="/events">Events View</a> &quot;My Assigned Events&quot; Filter<ul>
<li>Added a new filter to the Events View that allows technicians to filter for events that they are assigned to. This filter is only visible if the user is also a technician.</li>
</ul>
</li>
</ul>
<p><strong>Technicians:</strong></p>
<ul>
<li><a href="/manage/technicians">Technicians View</a><ul>
<li>Added a &quot;Techs&quot; column to the list view that shows all the technicians that are assigned to a given event.</li>
</ul>
</li>
</ul>
<h3 id="bug-fixes-12">Bug Fixes</h3>
<p><strong>Events:</strong></p>
<ul>
<li><a href="/events/calendar">Events Calendar View</a><ul>
<li>List View table columns are now aligned correctly.</li>
</ul>
</li>
</ul>
<hr/>
<h1 id="v2340">v2.34.0</h1>
<p><em><strong>Released</strong>: November 4th, 2022</em></p>
<h3 id="features-2">Features</h3>
<p><strong>Technicians:</strong></p>
<ul>
<li><a href="/manage/technicians">Technicians View</a><ul>
<li>Allows users to view all events in a calendar view</li>
<li>Allows users to filter events by assigned technicians</li>
<li>Allows admins to update assigned technicians for events</li>
<li>Includes an &quot;Export Schedule&quot; button that allows users to export the events in the calendar view to a pdf file</li>
</ul>
</li>
</ul>
<hr/>
<h1 id="v2332">v2.33.2</h1>
<p><em><strong>Released</strong>: October 28th, 2022</em></p>
<h3 id="bug-fixes-13">Bug Fixes</h3>
<ul>
<li>Fixed a bug addressing poor performance of Event Keyword search/select</li>
<li>Fixed a bug where Event Minutes couldn&#39;t be exported/uploaded to the associated Event.</li>
</ul>
<hr/>
<h1 id="v2331">v2.33.1</h1>
<p><em><strong>Released</strong>: October 21st, 2022</em></p>
<h3 id="updates-3">Updates</h3>
<ul>
<li>Updated Agenda Logger to v1.5.122, which now allows for minute uploads</li>
</ul>
<hr/>
<h1 id="v2330">v2.33.0</h1>
<p><em><strong>Released</strong>: September 10th, 2022</em></p>
<h3 id="features-3">Features</h3>
<p><strong>Events: Break Override:</strong></p>
<ul>
<li>Allows Clients to mark the Event as Paused in our system, but continue to display the Video Feed</li>
</ul>
<h3 id="documentation">Documentation:</h3>
<ul>
<li><a href="https://invintus-support.freshdesk.com/support/solutions/articles/48001221799-event-automation">https://invintus-support.freshdesk.com/support/solutions/articles/48001221799-event-automation</a></li>
</ul>
<hr/>
<h1 id="v2321">v2.32.1</h1>
<p><em><strong>Released</strong>: September 8th, 2022</em></p>
<h3 id="updates-4">Updates</h3>
<ul>
<li>Updated Video Editor &#40;@invintusmedia/editor&#41; to v1.2.11</li>
</ul>
<hr/>
<h1 id="v2320">v2.32.0</h1>
<p><em><strong>Released</strong>: September 2nd, 2022</em></p>
<h3 id="features-4">Features</h3>
<p><strong>Events:</strong></p>
<ul>
<li><p><a href="/events/slim">Events Slim View</a> now displays the date-range filter values</p>
</li>
<li><p>When creating a live event, the option to go directly to break after the stream starts is provided by a toggle switch in the <strong>Event Automation</strong> tab. This option is also included in the <strong>Automation</strong> tab when viewing any specific event</p>
</li>
</ul>
<p><strong><a href="/import">Batch Event Importer:</a></strong></p>
<ul>
<li>Added an Estimated Runtime Input</li>
<li>Added a Go To Break On Start Toggle Switch &#40;option to go directly to break after the stream starts&#41;</li>
<li>Additional CSV Values:<br/>
  <strong>Column</strong>      | <strong>Format</strong> | <strong>Is Required</strong> <br/>
  estRuntime  | String, HH:mm, 24:00 Max | No <br/>
  liveToBreak | String, TRUE or FALSE, all Caps | No</li>
</ul>
<h3 id="bug-fixes-14">Bug Fixes</h3>
<ul>
<li><a href="/manage/technicians/schedule">Technicians Schedule Page</a> no longer displays a 401 error</li>
</ul>
<hr/>
<h1 id="v2311">v2.31.1</h1>
<p><em><strong>Released</strong>: August 25th, 2022</em></p>
<h3 id="features-5">Features</h3>
<p><strong>Events:</strong></p>
<ul>
<li>Calendar views and sub-views now have adjusted colors to improve readability of multiple Events which are in concurrent timeslots.</li>
</ul>
<hr/>
<h1 id="v2310">v2.31.0</h1>
<p><em><strong>Released</strong>: August 19th, 2022</em></p>
<h3 id="features-6">Features</h3>
<p><strong>Events:</strong></p>
<ul>
<li>Added a Feature for displaying Estimated Run Time on your Events<ul>
<li>Calendar View: Effects how Events are displayed in the Month, Week, Monday-Friday, and Day views</li>
<li>The Create Event wizard and the Event&#39;s General Tab views now provide an Estimated Run Time input box<ul>
<li>Format is <code>Hours:Minutes</code> in 24 hour time</li>
<li>Defaults to 1 hour</li>
<li>Cannot exceed 24 hours in duration</li>
<li>Minimum duration of 1 minute</li>
<li>Only works for Events which will go Live at some point; unavailable for VoD Events.</li>
</ul>
</li>
</ul>
</li>
</ul>
<hr/>
<h1 id="v2302">v2.30.2</h1>
<p><em><strong>Released</strong>: August 16th, 2022</em></p>
<h3 id="updates-5">Updates</h3>
<ul>
<li>Added tabs to the release notes route</li>
</ul>
<hr/>
<h1 id="v2301">v2.30.1</h1>
<p><em><strong>Released</strong>: August 11th, 2022</em></p>
<h3 id="updates-6">Updates</h3>
<ul>
<li>Renamed &quot;Event Broadcasts&quot; chart label to &quot;Number of Events&quot; for clarity</li>
<li>Account Usage: displaying &quot;Unlimited&quot; for unlimited storage plans</li>
<li>Standardized &quot;VOD&quot; naming across usage components</li>
</ul>
<hr/>
<h1 id="v2300">v2.30.0</h1>
<p><em><strong>Released</strong>: June 25th, 2022</em></p>
<h3 id="features-7">Features</h3>
<h4 id="control-center">Control Center</h4>
<p>Refactored and updated the Client Account Usage and Billing view</p>
<ul>
<li>Added a Date filter to view historical consumption/usage data &#40;see note below&#41;</li>
<li>Added Account Bandwidth Consumption graph</li>
<li>Added Account Storage Consumption graph</li>
<li>Live vs VOD bandwidth  totals</li>
<li>Top Events by Bandwidth consumption</li>
<li>Number of Events broadcast for a given date range &#40;month/week/year&#41;</li>
<li>Most watched Events</li>
<li>Totals:<ul>
<li>Live Hours Produced</li>
<li>Events Scheduled</li>
<li>Live Captioning Minutes processed</li>
<li>Encoder Sources</li>
<li>Video-on-Demand Hours produced</li>
<li>Transcription Minutes processed</li>
</ul>
</li>
</ul>
<p><strong>Notes:</strong></p>
<p><em>Date Filters:</em></p>
<ul>
<li>Currently we can only support reporting data going back to May 1st, 2021</li>
</ul>
<p><em>Permissions:</em></p>
<ul>
<li>Only users with the correct Security Group Roles permissions &#40;<strong>Account - Read Billing</strong>&#41; will be able to see this page</li>
</ul>
<hr/>
<h1 id="v2294">v2.29.4</h1>
<p><em><strong>Released</strong>: May 13th, 2022</em></p>
<h3 id="bug-fixes-15">Bug Fixes</h3>
<h4 id="control-center-1">Control Center</h4>
<ul>
<li>Addressed multiple bugs in the Keywords manager interface:<ul>
<li>Now displays Keywords when first one is created</li>
<li>Fixed issue with deleting Keywords in the middle of the collection</li>
<li>When Keyword is created, change to correct page where it was inserted.</li>
</ul>
</li>
</ul>
<hr/>
<h1 id="v2293">v2.29.3</h1>
<p><em><strong>Released</strong>: May 6th, 2022</em></p>
<h3 id="bug-fixes-16">Bug Fixes</h3>
<h4 id="control-center-2">Control Center</h4>
<ul>
<li>Fixed an issue where Descriptions wouldn&#39;t display properly in the Event&#39;s Slim view</li>
<li>Fixed an issue where the Channel Listing manager wouldn&#39;t load</li>
<li>Fixed an issue where the Keyword Manager would consume too much memory and crash the browser</li>
</ul>
<hr/>
<h1 id="v2292">v2.29.2</h1>
<p><em><strong>Released</strong>: April 30th, 2022</em></p>
<h3 id="features-and-updates">Features and Updates</h3>
<h4 id="control-center-3">Control Center</h4>
<ul>
<li>New <code>/release-notes</code> route &#40;this page&#41; for  changes and releases across our application ecosystem</li>
</ul>
<h3 id="bug-fixes-17">Bug Fixes</h3>
<h4 id="control-center-4">Control Center</h4>
<ul>
<li>Fixed an issue where closing an Event in the Slim view would cause the Analytics previously loaded to disappear.</li>
<li>Fixed an issue where users could request non-existent pages in the Events list.</li>
</ul>
<hr/>
<h1 id="v2290">v2.29.0</h1>
<p><em><strong>Released</strong>: April 25th, 2022</em></p>
<h3 id="features-and-updates-1">Features and Updates</h3>
<h4 id="keyword-manager">Keyword Manager</h4>
<ul>
<li>Refactored the Keyword management view to reflect the capabilities of our API<ul>
<li>Batch delete keywords</li>
<li>View assigned Events to any given Keyword</li>
</ul>
</li>
</ul>
<h4 id="analytics">Analytics</h4>
<ul>
<li>Analytics system overhauled on the backend</li>
</ul>
<h3 id="bug-fixes-18">Bug Fixes</h3>
<h4 id="analytics-1">Analytics</h4>
<ul>
<li>Events analytics overview updated</li>
<li>Analytics view for the Event details view updated</li>
<li>Dashboard landing page now provides analytics by Geolocation</li>
</ul>
<hr/>
<h1 id="v22850">v2.28.50</h1>
<p><em><strong>Released</strong>: March 4th, 2022</em></p>
<h3 id="bug-fixes-19">Bug Fixes</h3>
<h4 id="embedded-player">Embedded Player</h4>
<ul>
<li>Fixed issue where the player was crashing for VOD events only in Safari</li>
</ul>
<h4 id="control-center-5">Control Center</h4>
<ul>
<li>Fixed Bulk Importer crashing when trying to import events that required creating new categories</li>
<li>Fixed an issue where creating a new Keyword from an Event cuased part of the view to crash</li>
</ul>
<h4 id="agenda-logger-5">Agenda Logger</h4>
<ul>
<li>Added fix for the case where Event&#39;s status wasn&#39;t updated when logging on an Asset</li>
<li>Adressed two realtime udpates bugs related to realtime updates not being consumed<ul>
<li>for Global tags socket updates not being handled</li>
<li>for the Edit panel not taking timecodes from log items when sending/receiving Edit actions</li>
</ul>
</li>
</ul>
<hr/>
<h1 id="v22848">v2.28.48</h1>
<p><em><strong>Released</strong>: February 25th, 2022</em></p>
<h3 id="bug-fixes-20">Bug Fixes</h3>
<h4 id="control-center-6">Control Center</h4>
<ul>
<li>Add note about preroll start time compared to event start time</li>
<li>Fixed issue where Keyword search was automatically clearing for no reason</li>
<li>Encoders<ul>
<li>Remove XML configuration in Encoder Source details</li>
<li>Add Encoder ID to source details</li>
</ul>
</li>
</ul>
<h4 id="agenda-logger-6">Agenda Logger</h4>
<ul>
<li>Fixed an issue were log item sorting does not rerender new sort position</li>
<li>Fixed issue where Event, attendee, and log item tags appear in the wrong position when created after items were deleted</li>
</ul>
<h4 id="embedded-video-player">Embedded Video Player</h4>
<ul>
<li>Fixed an issue where the Document viewer/side panel wasn&#39;t appearing in all cases</li>
</ul>
<hr/>
<h1 id="v22846">v2.28.46</h1>
<p><em><strong>Released</strong>: February 18th, 2022</em></p>
<h3 id="features-8">Features</h3>
<h4 id="event-chat">Event Chat</h4>
<ul>
<li>Added users export button for moderators</li>
</ul>
<h3 id="bug-fixes-21">Bug Fixes</h3>
<h4 id="player">Player</h4>
<ul>
<li>Fixed issue were some players were broken during initialization</li>
<li>Player now displays current log item even when the Event is &quot;on break&quot;</li>
<li>Chat tab set to take up required space even while it is not setup/started</li>
</ul>
<h4 id="agenda-logger-7">Agenda Logger</h4>
<ul>
<li>Adressed an issue where certain requests failed with a 500 error</li>
</ul>
<hr/>
<h1 id="v22845">v2.28.45</h1>
<p><em><strong>Released</strong>: February 11th, 2022</em></p>
<h3 id="bug-fixes-22">Bug Fixes</h3>
<h4 id="control-center-7">Control Center</h4>
<ul>
<li>Fixed an issue in the OTT manager where image edits for persistent streams did nothing</li>
<li>Fixed an edge case where realtime updates weren&#39;t being interpreted correctly</li>
<li>Fixed the &quot;Today&quot; filter where it wasn&#39;t showing Events based on timezone offset from local tz &#40;eg events before 8am for PST&#41;</li>
<li>Fixed an issue where searching for an Event by ID gives &quot;can&#39;t access property replace&quot;</li>
</ul>
<h4 id="channel-listings">Channel Listings</h4>
<ul>
<li>Added a link to Event in Calendar links</li>
<li>Fixed an issue with the date and time being incorrect in the outlook.com calendar link</li>
</ul>
<h4 id="agenda-logger-8">Agenda Logger</h4>
<ul>
<li>Fixed an issue where categories weren&#39;t filtering events coming from sockets/realtime updates in the Events list</li>
<li>Fixed edit panel timecodes not being reset when reset is clicked</li>
</ul>
<hr/>
<h1 id="v22844">v2.28.44</h1>
<p><em><strong>Released</strong>: February 4th, 2022</em></p>
<h3 id="bug-fixes-23">Bug Fixes</h3>
<h4 id="agenda-logger-9">Agenda Logger</h4>
<ul>
<li>Fixed an issue where Current Item wasn&#39;t being set correctly in some cases in the UI</li>
</ul>
<h4 id="control-center-8">Control Center</h4>
<ul>
<li>Fixed an issue where some input fields would stop accepting spaces to be entered</li>
<li>Fixed an issue with the Editor where opening it a second time would cause it to get stuck loading</li>
<li>Old Encoder not found in client encoders throws an error<ul>
<li>Old events with encoders that were deleted still had the encoder assigned to the event but it didn&#39;t exist in the client encoders</li>
</ul>
</li>
</ul>
<h4 id="channel-listings-1">Channel Listings</h4>
<ul>
<li>Moved calendar reminder button into table as a column for the table view</li>
</ul>
<hr/>
<h1 id="v22843">v2.28.43</h1>
<p><em><strong>Released</strong>: January 28th, 2022</em></p>
<h3 id="bug-fixes-24">Bug Fixes</h3>
<h4 id="control-center-9">Control Center</h4>
<ul>
<li>Added &#39;Add to calendar&#39; preference to the Channel Listings editor</li>
<li>Safari event list tab change fix, required adjusting querystrings for start/stop dates, removing spaces which was invalidating the dates</li>
<li>Updated wording for realtime error messages</li>
</ul>
<h4 id="embedded-video-player-1">Embedded Video Player</h4>
<ul>
<li>Added &#39;Add to calendar&#39; button next to share icons for events that have start time longer than 1 hour away</li>
</ul>
<h4 id="channel-listings-2">Channel Listings</h4>
<ul>
<li>Added &#39;Add to calendar&#39; button to all listing views</li>
</ul>
</Fragment>);
    export default Markdown;
  